<button
  type="button"
  (click)="openContactSalesLandingPage($event)"
  mat-raised-button
  [color]="color"
  [ngClass]="buttonClass">
  {{ buttonText }}
</button>
